/*
 * @@Description:
 * @@Author: MuYang
 * @Date: 2021-08-10 10:02:45
 * @LastEditTime: 2021-10-12 16:02:07
 */
import { parseUnit } from '../../util/index'
export default {
  name: 'ColGroup',
  props: ['columns'],

  render (h) {
    const { columns } = this.$props
    const colTemplate = columns.map(({ realWidth }) => {
      let w = parseUnit(realWidth)
      return <col width={w}></col>
    })
    return <colgroup>{colTemplate}</colgroup>
  }
}
